import type { ButtonHTMLAttributes } from 'react'
import { cn } from '@/helpers/utils'
import { BrandGradientOverlay } from './brand-gradient-overlay'
import { buttonVariants } from './button-legacy'

export interface ButtonStyleProps {
	shape?: 'rectangle' | 'square' | 'rounded'
	size?: 'sm' | 'md' | 'lg' | 'xl'
	className?: string
}

export type ButtonBrandProps = ButtonHTMLAttributes<HTMLButtonElement> &
	ButtonStyleProps & {
		ref?: React.Ref<HTMLButtonElement>
	}

/**
 * @deprecated Legacy brand button. Use `ButtonBrand` from
 * `@/components/ui/button-brand` (ported from airbnb-elevate-fe) for new code.
 */
function ButtonBrandLegacy({
	shape = 'rectangle',
	size = 'md',
	className,
	children,
	ref,
	...props
}: ButtonBrandProps) {
	return (
		<button
			className={buttonVariants({
				variant: 'brand',
				size,
				shape,
				className: cn('group', className)
			})}
			data-slot='button'
			ref={ref}
			{...props}
		>
			<BrandGradientOverlay />
			<span className='relative z-2 flex items-center justify-center'>
				{children}
			</span>
		</button>
	)
}

export { ButtonBrandLegacy }
